module.exports = __webpack_public_path__ + "static/media/Agenda7.e23d4a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda7.png
// module id = 1971
// module chunks = 0